'use strict';

angular.module('AcaApp').factory('FormService',
[
  'FormResource',
  function(FormResource){
    //jscs:disable validateNewlineAfterArrayElements
    var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    return{
      save1095C: function(form, flagValidation){
        var rpcConfig = {method: 'save1095C', params: [form, flagValidation]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      save1095CDependent: function(dependents, flagValidation){
        var rpcConfig = {method: 'save1095CDependent', params: [dependents, flagValidation]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      save1095BCoveredIndividuals: function(dependents, flagValidation){
        var rpcConfig = {method: 'save1095BCoveredIndividuals', params: [dependents, flagValidation]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      save1095B: function(form, flagValidation){
        var rpcConfig = {method: 'save1095B', params: [form, flagValidation]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      getFormByRecno: function(recno){
        var rpcConfig = {method: 'GetFormByRecno', params: [recno]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      get1095CForms: function(recno){
        var rpcConfig = {method: 'Get1095CFormsByRecno', params: [recno]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      get1095BForms: function(recno){
        var rpcConfig = {method: 'Get1095BFormsByRecno', params: [recno]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      getSubscriberFormsByModrecno: function(modrecno, fchar){
        var rpcConfig = {method: 'GetSubscriberList', params: [modrecno, fchar]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      get1095BFormByModrecno: function(modrecno){
        var rpcConfig = {method: 'Get1095BFormByModRecno', params: [modrecno]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      get1095CFormByModrecno: function(modrecno){
        var rpcConfig = {method: 'Get1095CFormByModRecno', params: [modrecno]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      update1095B: function(subscriber, flagValidation){
        var rpcConfig = {method: 'Update1095B', params: [subscriber, flagValidation]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      exclude1095B: function(subscriber){
        var rpcConfig = {method: 'Exclude1095B', params: [subscriber]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      update1095C: function(subscriber, flagValidation){
        var rpcConfig = {method: 'Update1095C', params: [subscriber, flagValidation]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      exclude1095C: function(subscriber){
        var rpcConfig = {method: 'Exclude1095C', params: [subscriber]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      isSubscriberExcluded: function(recno, fchar){
        var rpcConfig = {method: 'IsSubscriberExcluded', params: [recno, fchar]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      getMonths: function(){
        return months;
      },
      Delete: function(form){
        var rpcConfig = {method: 'DeleteForm', params: [form]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      save1094c: function(form){
        var rpcConfig = {method: 'save1094C', params: [form]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      getX5CRecordsCountByEmployer: function(ptin){
        var rpcConfig = {method: 'GetX5BRecordsCountByEmployer', params: [ptin]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      AreThereFormsMarkedAsPrinted: function(tin){
        var rpcConfig = {method: 'AreThereFormsMarkedAsPrinted', params: [tin]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      save1094b: function(form){
        var rpcConfig = {method: 'save1094B', params: [form]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      GetAleGroupByEmployer: function(ptin){
        var rpcConfig = {method: 'GetAleGroupList', params: [ptin]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      GetAleMonthlyByEmployer: function(ptin){
        var rpcConfig = {method: 'GetAleMonthlyByEmployer', params: [ptin]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      update1094c: function(form, oldGroup){
        var rpcConfig = {method: 'update1094C', params: [form, oldGroup]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      DeleteAleMember: function(aleMember){
        var rpcConfig = {method: 'DeleteAleMember', params: [aleMember]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      areThereX5BPrinted: function(form){
        var rpcConfig = {method: 'AreThereX5BPrinted', params: [form]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      areThereX5CPrinted: function(form){
        var rpcConfig = {method: 'AreThereX5CPrinted', params: [form]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      deleteAleGroupMembers: function(ptin){
        var rpcConfig = {method: 'DeleteAleGroupMembers', params: [ptin]};
        return FormResource.executeRpc(rpcConfig).$promise;
      },
      deleteAleMonthlyMembers: function(ptin){
        var rpcConfig = {method: 'DeleteAleMonthlyMembers', params: [ptin]};
        return FormResource.executeRpc(rpcConfig).$promise;
      }
    };
  }
]);
